import { GridFlex } from '@utils/Containers'
import { StyledLink } from '@utils/StyledLink'
import { fontSizes } from '@utils/Typography'
import { getImage } from 'gatsby-plugin-image'
import { Box, Text } from 'mds-web-ui'
import React from 'react'
import {
  HEADING_COLOR_DARK,
  HEADING_COLOR_LIGHT,
  TEXT_COLOR_DARK,
  TEXT_COLOR_LIGHT
} from './constants'
import { SingleAppLink } from './SingleAppLink'

export const AppContent = ({
  imageData,
  px = 3,
  py = 3,
  gap = 1,
  theme,
  ...props
}) => {
  const timepageIconImage = getImage(imageData.timepageIconImage)
  const flowIconImage = getImage(imageData.flowIconImage)
  const actionsIconImage = getImage(imageData.actionsIconImage)
  const overlapIconImage = getImage(imageData.overlapIconImage)

  const headingColor =
    theme === 'light' ? HEADING_COLOR_LIGHT : HEADING_COLOR_DARK
  const textColor = theme === 'light' ? TEXT_COLOR_LIGHT : TEXT_COLOR_DARK

  return (
    <>
      <GridFlex
        px={px}
        py={py}
        {...props}
        gap={gap}
        flexDirection="column"
        width="100%"
      >
        <SingleAppLink
          image={timepageIconImage}
          title="Timepage"
          to="/timepage/"
          alt="Timepage app icon"
          headingColor={headingColor}
          textColor={textColor}
        >
          Beautiful calendar and weather
        </SingleAppLink>
        <SingleAppLink
          image={actionsIconImage}
          title="Actions"
          to="/actions/"
          alt="Actions app icon"
          headingColor={headingColor}
          textColor={textColor}
        >
          Elegant, fun todo list
        </SingleAppLink>

        <SingleAppLink
          image={flowIconImage}
          title="Flow"
          to="/flow/"
          alt="Flow app icon"
          headingColor={headingColor}
          textColor={textColor}
        >
          Infinite notebook
        </SingleAppLink>
        <SingleAppLink
          image={overlapIconImage}
          title="Overlap"
          to="/overlap/"
          alt="Overlap app icon"
          headingColor={headingColor}
          textColor={textColor}
        >
          Time zones made simple
        </SingleAppLink>

        <StyledLink
          to="/duo/"
          fontSize={fontSizes.body}
          px={3}
          py={3}
          fontWeight="600"
          width="100%"
          justifyContent="center"
          textAlign="center"
          mt={2}
          aria-label="See Bonobo apps on iPhone Duo"
        >
          Our apps on iPhone Duo →
        </StyledLink>
      </GridFlex>
      <Box px={px} py={py} width="100%" bg="rgba(0,0,0,0.02)">
        <GridFlex width="100%" flexDirection="column" p={2}>
          <Text
            as="h2"
            fontWeight="700"
            m={0}
            fontSize={fontSizes.body}
            color={headingColor}
          >
            The Bonobo Bundle
          </Text>
          <Text
            as="p"
            mt={1}
            mb={0}
            color={textColor}
            fontSize={fontSizes.body}
          >
            All three essential apps for one low price
          </Text>
          <StyledLink
            to="/bundle"
            fontSize={fontSizes.body}
            px={3}
            py={3}
            color="#FFF"
            bg="#38ca76"
            fontWeight="600"
            width="100%"
            justifyContent="center"
            textAlign="center"
            mt={3}
            aria-label="Learn more about the Bonobo Bundle"
          >
            The Bonobo Bundle →
          </StyledLink>
        </GridFlex>
      </Box>
    </>
  )
}
